// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mnVdc","label":"styles_label__Lcj0h"};